import { Typography, useTheme, Box, Grid, Stack, Divider } from '@mui/material';

// Components
import { IContributeDetailCompany } from 'src/utils/typings/response/contribute';
import { renderTextOrDefault } from 'src/utils/helpers/stringHelpers';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import { MailOutlined, PhoneOutlined } from '@mui/icons-material';
import { isEmpty } from 'lodash';

const ContactInformation = ({ dataContribution }: { dataContribution: IContributeDetailCompany }) => {
  const theme = useTheme();

  return (
    <Grid container gap={1} wrap="nowrap">
      {getArrayDefault(
        dataContribution?.contribution_contact_company_profile?.map((item, index) => (
          <Grid key={`contribute-email-company-${index}`} item xs={6}>
            <Box
              width="100%"
              padding={2}
              border={`1px dashed ${theme.palette.divider}`}
              borderRadius={theme.shape.borderRadius / 2}
            >
              <Typography align="left" variant="caption2" color="text.secondary" component="p">
                Contact {index + 1}
              </Typography>
              <Box mt={1} />
              <Box textAlign="left">
                <Typography align="left" component="span" variant="body2" color="text.primary">
                  {renderTextOrDefault(item.full_name)}
                </Typography>
                <Box
                  mx={1}
                  component="span"
                  display="inline-block"
                  sx={{
                    width: '6px',
                    height: '6px',
                    backgroundColor: theme.palette.divider,
                    borderRadius: 1000,
                  }}
                />

                <Typography align="left" component="span" variant="body2" color="text.primary">
                  {renderTextOrDefault(item.title)}
                </Typography>
              </Box>
              <Box mt={1} />
              <Stack direction="row" spacing={2} divider={<Divider orientation="vertical" flexItem />}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <MailOutlined fontSize="small" color="primary" />
                  <Typography align="left" variant="caption2" color="text.secondary" component="span">
                    {renderTextOrDefault(item.email)}
                  </Typography>
                </Stack>
                {!isEmpty(item.phone_number) && (
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <PhoneOutlined fontSize="small" color="primary" />
                    <Typography align="left" variant="caption2" color="text.secondary" component="span">
                      {renderTextOrDefault(item.phone_number)}
                    </Typography>
                  </Stack>
                )}
              </Stack>
            </Box>
          </Grid>
        )),
      )}
    </Grid>
  );
};

export default ContactInformation;
